import { render, staticRenderFns } from "./ResultFormSeTd.vue?vue&type=template&id=4fbe0e7a&scoped=true&"
import script from "./ResultFormSeTd.vue?vue&type=script&lang=js&"
export * from "./ResultFormSeTd.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormSeTd.vue?vue&type=style&index=0&id=4fbe0e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe0e7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbe0e7a')) {
      api.createRecord('4fbe0e7a', component.options)
    } else {
      api.reload('4fbe0e7a', component.options)
    }
    module.hot.accept("./ResultFormSeTd.vue?vue&type=template&id=4fbe0e7a&scoped=true&", function () {
      api.rerender('4fbe0e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSeTd.vue"
export default component.exports